<div class="container">
    <div class="contact-form-container">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
            <mat-form-field appearance="fill" class="full-width form-field">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" type="text" required>
                @if (name.invalid && (name.dirty || name.touched)) {
                    <mat-error>Bitte geben Sie Ihren Namen ein</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill" class="full-width form-field">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" type="email" required>
                @if(email.invalid && (email.dirty || email.touched)){
                <mat-error class="mat-label-medium">
                    {{ errorMessage }}
                </mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill" class="full-width form-field">
                <mat-label>Telefonnummer</mat-label>
                <input matInput formControlName="phone" type="text" pattern="[0-9]*">
                @if(phone.invalid && (phone.dirty || phone.touched)){
                    <mat-error class="mat-label-medium">Bitte gib eine gültige Telefonnummer ein</mat-error>
                }
            </mat-form-field>
            <mat-form-field appearance="fill" class="full-width form-field">
                <mat-label>Nachricht</mat-label>
                <textarea matInput formControlName="message" type="text" required></textarea>
                @if (message.invalid && (message.dirty || message.touched)) {
                    <mat-error>Bitte schreibe eine kurze Nachricht, worum es geht</mat-error>
                }
            </mat-form-field>
            <div class="terms-container">
                <mat-checkbox formControlName="termsAccepted" required>
                    <span class="custom-label-medium">
                    Ich habe die 
                    <a href="/datenschutz" target="_blank" (click)="$event.stopPropagation()">Datenschutzerklärung</a>
                    zur Kenntnis genommen. Ich stimme zu, dass meine Angaben zur Kontaktaufnahme und für Rückfragen dauerhaft gespeichert werden.
                    </span>
                </mat-checkbox>
            </div>
            <ng-container>
                @if (submissionStatus=="pending"){
                    <div class="progress-bar-container">
                        <mat-progress-bar mode="indeterminate" class="progress-bar"></mat-progress-bar>
                    </div>
                } 
                @else {
                <button mat-flat-button [class.active-button]="contactForm.valid"
                    [class.disabled-button]="!contactForm.valid || submissionStatus=='error'" type="submit" [disabled]="contactForm.invalid || submissionStatus=='error'">Senden
                </button>
                }
            </ng-container>
        </form>
        @if (submissionMessage){
        <div class="mat-label-medium" role="status" aria-live="polite">{{submissionMessage}}</div>
        }
    </div>
</div>